export const MODULE_NAME = "soc/2023";
